import React from 'react';
import Vibeu from '../images/vibeu-logo.png';

const Footer = () => {
    return (
        <footer className="glass-footer py-10">
            <div className="container max-w-5xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <img src={Vibeu} className="h-8 rounded-full" alt="vibeu logo" />
                    <span className="text-sm" style={{ color: 'rgba(255,255,255,0.3)' }}>
                        &copy; {new Date().getFullYear()} vibeu.tech
                    </span>
                </div>
                <div className="flex items-center gap-6 text-sm" style={{ color: 'rgba(255,255,255,0.38)' }}>
                    {[
                        { label: 'About',    href: '#about' },
                        { label: 'Projects', href: '#projects' },
                        { label: 'Blog',     href: '#blog' },
                    ].map(({ label, href }) => (
                        <a
                            key={label}
                            href={href}
                            className="hover:text-orange-400 transition-colors duration-200 cursor-pointer"
                        >
                            {label}
                        </a>
                    ))}
                    <a
                        href="https://github.com/Vybeu"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-orange-400 transition-colors duration-200 cursor-pointer"
                    >
                        GitHub
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
